// extracted by mini-css-extract-plugin
export default {"categories":"categories_categories__sddFE","item":"categories_item__WsHjm"};